import {
    USER_DELETE_FRUI_PFBZ_BEGIN,
    USER_DELETE_FRUI_PFBZ_SUCCESS,
    USER_DELETE_FRUI_PFBZ_FAILURE,
    USER_DELETE_FRUI_PFBZ_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function deleteFrui_pfbz(id) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: USER_DELETE_FRUI_PFBZ_BEGIN,
      });
  
      // Return a promise so that you could control UI flow without states in the store.
      // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
      // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
      // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
      const promise = new Promise((resolve, reject) => {
          request({
            method:'DELETE',
            url:`/api/basic/standard/${id}`,
          }).then( data => {
              dispatch({
                  type: USER_DELETE_FRUI_PFBZ_SUCCESS,
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: USER_DELETE_FRUI_PFBZ_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissDeleteFrui_pfbzError() {
    return {
      type: USER_DELETE_FRUI_PFBZ_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case USER_DELETE_FRUI_PFBZ_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          deleteFrui_pfbzPending: true,
          deleteFrui_pfbzError: null,
        };
  
      case USER_DELETE_FRUI_PFBZ_SUCCESS:
        // The request is success
        return {
          ...state,
          deleteFrui_pfbzPending: false,
          deleteFrui_pfbzError: null,
        };
  
      case USER_DELETE_FRUI_PFBZ_FAILURE:
        // The request is failed
        return {
          ...state,
          deleteFrui_pfbzPending: false,
          deleteFrui_pfbzError: action.data.error,
        };
  
      case USER_DELETE_FRUI_PFBZ_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          deleteFrui_pfbzError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/user/redux/deleteFrui_pfbz.js